export default {
  form: {
    header: {
      label: 'Kopfzeile',
      placeholder: 'Kopfzeile',
    },
    discount_badge: {
      label: 'Rabatt-Abzeichen',
      placeholder: '10 EUR',
    },
    description: {
      label: 'Beschreibung',
      placeholder: 'Beschreibung',
    },
    qr_code_header: {
      label: 'UI-Box-Kopfzeile',
      placeholder: 'UI-Box-Kopfzeile',
    },
    qr_code_description: {
      label: 'UI box Beschreibung',
      placeholder: 'UI box Beschreibung',
    },
    footer: {
      label: 'Text in der Fußzeile',
      placeholder: 'Fußzeilentext eingeben',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL auswählen',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primäre Farbe',
    },
    background_color: {
      label: 'Hintergrundfarbe',
    },
    cover_image: {
      label: 'Titelbild',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flugblatt konnte nicht geladen werden',
  },
};
